import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-3 pt-1" }
const _hoisted_2 = {
  for: "category-active",
  class: "d-flex align-items-center cursor-pointer"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Active", -1)
const _hoisted_4 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, _mergeProps({
    title: _ctx.name || 'Create a new',
    opened: _ctx.opened
  }, _ctx.$attrs, { onHide: _ctx.hide }), {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", null, [
          _createVNode(_component_AppInputsValidationProvider, { onChangeErrorState: _ctx.onChangeErrorState }, {
            default: _withCtx(() => [
              _createVNode(_component_AppInput, {
                id: "create-user-name",
                modelValue: _ctx.modalValue.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalValue.title) = $event)),
                "input-type": "material",
                label: "Title",
                type: "text",
                "validation-type": "name",
                name: "name"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["onChangeErrorState"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("label", _hoisted_2, [
              _createVNode(_component_AppCheckbox, {
                id: "category-active",
                modelValue: _ctx.modalValue.active,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalValue.active) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_3
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppButton, {
            disabled: _ctx.modalValue.title.length < 3,
            loading: _ctx.isLoading,
            type: "secondary",
            size: "xl",
            onClick: _ctx.submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Save ")
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])
        ])
      ], 32)
    ]),
    _: 1
  }, 16, ["title", "opened", "onHide"]))
}